import store from '../store/store';
import { getFallbackValueIfNull } from 'owa-options-core';
import { getUserConfiguration, updateUserConfigurationAndService } from 'owa-session-store';

export default async function saveMessagePreviewOption() {
    await onMessagePreviewToggle(store.showPreviewTextInListView);
}

export async function onMessagePreviewToggle(isEnabled: boolean) {
    const newValue = getFallbackValueIfNull(
        isEnabled,
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2532 (15,9): Object is possibly 'undefined'.
        // @ts-expect-error
        getUserConfiguration().UserOptions.ShowPreviewTextInListView
    );

    await updateUserConfigurationAndService(
        config => {
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2532 (23,13): Object is possibly 'undefined'.
            // @ts-expect-error
            config.UserOptions.ShowPreviewTextInListView = newValue;
        },
        [
            {
                key: 'ShowPreviewTextInListView',
                valuetype: 'Boolean',
                value: [`${newValue}`],
            },
        ]
    );
}
